module.exports = __webpack_public_path__ + "media/images/top_menu_icon/hotels_index-5f5b25e3115dd02656a350a17721f562.png";